import { Component, OnInit, signal } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  LoggedUser,
  PtConsoleRoutes,
  PtPermissions,
  PtUiAppRoutes,
} from '@pt/pt-models';
import { map, take } from 'rxjs/operators';

import { PtCoreActions, UrlUtils } from '@pt/pt-core';
import { AuthPermissionsUtils, AuthService } from '@pt/api-client';
import { LoginResponse } from 'it/primatoo/openapi/api/adm/schemas/login/LoginResponse';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'pt-oauth',
  template: `
    <div class="loader-container">
      <pt-loading-page></pt-loading-page>
    </div>
  `,
  styles: [
    `
      .loader-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100vh;
      }
    `,
  ],
})
export class OauthComponent implements OnInit {
  protected showError = signal(false);

  constructor(
    private store: Store,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.pipe(take(1)).subscribe((params) => {
      const err = params['err'];
      if (err) {
        this.handleError();
      } else {
        this.handleSuccess();
      }
    });
  }

  private handleError(): void {
    this.store.dispatch(
      PtCoreActions.logoutAndClearData({
        route: [PtConsoleRoutes.LOGIN],
        domain: UrlUtils.getDomainIfExists(),
        queryParams: { err: 'oauth' },
      })
    );
  }

  private handleSuccess(): void {
    this.authService
      .authSelf()
      .pipe(
        map((response: LoginResponse) => {
          const enumeratedPermissions: PtPermissions[] =
            AuthPermissionsUtils.buildPermissions(
              response.system,
              response.permissions
            );
          const out: LoggedUser = {
            ...response,
            email: response.email,
            enumeratedPermissions,
          };
          return out;
        })
      )
      .subscribe({
        next: (loggedUser: LoggedUser) => {
          this.store.dispatch(
            PtCoreActions.loginSuccess({ loginResponse: loggedUser })
          );
          this.store.dispatch(
            PtCoreActions.navigateTo({ route: [PtUiAppRoutes.LOADER] })
          );
        },
        error: () => {
          this.handleError();
        },
      });
  }
}
